export enum TileLayerEnum {
    GoogleMapHybrid = 1,
    GoogleMapsSatellite,
    GoogleMapsRoads,
    ArcGIS,
    OpenStreetMap,
    OpenStreetMap2,
    ThunderForestTopography,
    TopographyMap,
    StadiaMap,
    WikiMediaMap,
    BingMap,
}
